// Roles de la AAP tal como viajan en el claim ``roles`` del JWT (con prefijo
// ``ROLE_``). MASTER es el rol interno de la casa de desarrollo (superset absoluto;
// el cliente no lo ve). Espejo de las constantes del backend (SharedAuth).
export const ROLE_MASTER = 'ROLE_MASTER';
export const ROLE_SUPERADMIN = 'ROLE_SuperAdmin';
export const ROLE_SUPERVISOR = 'ROLE_Supervisor';
export const ROLE_OPERADOR = 'ROLE_Operador';

/**
 * Roles que pueden ver/gestionar las páginas de Usuarios y Entidades: todos menos
 * Operador (que solo opera su almacén). Se usa para filtrar el menú y en los guards.
 */
export const MANAGEMENT_ROLES: string[] = [ROLE_MASTER, ROLE_SUPERADMIN, ROLE_SUPERVISOR];

/**
 * Roles que ven las pantallas de configuración técnica (Bodegas): solo
 * SuperAdmin y el MASTER interno. Un Supervisor está acotado a su empresa y la
 * pantalla muestra el catálogo completo del ERP.
 */
export const ADMIN_ROLES: string[] = [ROLE_MASTER, ROLE_SUPERADMIN];

/**
 * Roles (valor sin prefijo ``ROLE_``, como los emite la AAP) que el usuario actual
 * puede asignar al crear/editar usuarios, según la jerarquía: cada nivel gestiona
 * SOLO los inferiores. Espejo de ``creatable_roles`` del backend.
 *   - MASTER → SuperAdmin, Supervisor, Operador
 *   - SuperAdmin → Supervisor, Operador
 *   - Supervisor → Operador
 *   - Otros → ninguno
 */
export function creatableRoleValues(hasRole: (role: string | string[]) => boolean): string[] {
  if (hasRole(ROLE_MASTER)) return ['SuperAdmin', 'Supervisor', 'Operador'];
  if (hasRole(ROLE_SUPERADMIN)) return ['Supervisor', 'Operador'];
  if (hasRole(ROLE_SUPERVISOR)) return ['Operador'];
  return [];
}
